var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-container',[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('hr'),(_vm.loading)?_c('loading'):_c('div',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],1),_c('global-error-snack-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }